module.exports = __webpack_public_path__ + "img/logo_off.3c1e160d.png";